import { useState } from "react"
import axios from "axios"



export default function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const handleLogin = async () => {
    try {
      const res = await axios.post("/api/login", {
        email,
        password
      }, { withCredentials: true });

      // Wenn Login erfolgreich ist
      if (res.data.success) {
        // Speichere das Token im LocalStorage
        localStorage.setItem("authToken", res.data.token);  // Token speichern
        localStorage.setItem("role", res.data.role);  // Rolle speichern (falls notwendig)
        localStorage.setItem("email", email);  // E-Mail des Benutzers speichern

        // Weiterleitung zur 2FA-Seite
        if (res.data.needs2FA) {
          window.location.href = `/2fa/setup?email=${email}`
        } else {
          window.location.href = `/2fa?email=${email}` 
        }
      } else {
        setError("Login failed");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError("Login failed");
    }
  };



  

  

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-10 w-full max-w-md">
        <div className="flex justify-center mb-6">
        <img
  src="/swissphone-logo.png"
  alt="Swissphone"
  style={{ maxWidth: "160px", height: "auto" }}
/>


        </div>
        <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">OTA Server</h1>
        <input
          type="email"
          placeholder="E-Mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-red-500"
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") handleLogin()
          }}
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-red-500"
        />
        <button
          onClick={handleLogin}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg transition duration-200"
        >
          Login
        </button>
        {error && (
          <p className="text-red-600 mt-4 text-center">{error}</p>
        )}
      </div>
    </div>
  )
}
